/* @flow */

import * as types from 'src/shared/app/topic/new/action/appNewTopicActionTypes';
import * as userTypes from 'src/shared/domain/user/action/userActionTypes';

import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  isReady: false,
  oneOnOneErrorMessage: null,
  groupErrorMessage: null,
  canCreateFishBowlTopic: null,
  fishbowlErrorMessage: null,

  // V2
  errorMessages: [],
  errorPageMessage: null,
  errorCodes: [],
  errorPageCode: null,
  kind: {
    offer: null, // enabled | disabled | hidden
    group: null,
    fishbowl: null,
  },
};

const _setReady = (state: Object) => ({
  ...state,
  isReady: true,
});

const _unsetReady = (state: Object) => ({
  ...state,
  isReady: false,
});

const _setCanCreate = (state: Object, action: Object) => {
  const {
    error_messages: errorMessages,
    error_page_message: errorPageMessage,
    error_codes: errorCodes,
    error_page_code: errorPageCode,
    kind: { offer, group, fishbowl },
  } = action.result;

  return {
    ...state,
    errorMessages,
    errorPageMessage,
    errorCodes,
    errorPageCode,
    kind: { offer, group, fishbowl },
  };
};

export default createReducer(initialState, {
  [types.SET_NEW_TOPIC_READY]: _setReady,
  [types.UNSET_NEW_TOPIC_READY]: _unsetReady,
  [userTypes.FETCH_USER_CAN_CREATE_TOPIC_SUCCESS]: _setCanCreate,
});
